export const TOKEN_LOADED = 'TOKEN_LOADED';
export const ADVISOR_LOGIN_LOADED = 'ADVISOR_LOGIN_LOADED';
